var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBottomBlackMedium({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 8,
    viewBox: "0 0 13 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3718 0.980618C12.7093 1.28932 12.7093 1.82108 12.3718 2.12978L7.17489 6.88276C6.79281 7.2322 6.20719 7.2322 5.82511 6.88276L0.628244 2.12978C0.290713 1.82108 0.290713 1.28932 0.628245 0.980618C0.92575 0.708525 1.38175 0.708525 1.67925 0.980618L5.82511 4.77235C6.20719 5.12179 6.79281 5.12179 7.17489 4.77235L11.3207 0.980618C11.6183 0.708524 12.0742 0.708525 12.3718 0.980618Z",
    fill: "#212325"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBottomBlackMedium);
export default __webpack_public_path__ + "static/media/arrow-bottom-black-medium.713e8bdade9db3b61ea34af9915353fe.svg";
export { ForwardRef as ReactComponent };